function safeObj(value) {
  return value && typeof value === 'object' ? value : {};
}

export function track(eventName, props = {}) {
  const name = String(eventName || '').trim();
  if (!name) return;
  const payload = safeObj(props);

  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    }
  } catch { /* ignore */ }

  try {
    if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
      window.plausible(name, { props: payload });
    }
  } catch { /* ignore */ }

  try {
    if (typeof window !== 'undefined' && window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(name, payload);
    }
  } catch { /* ignore */ }

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.debug('[analytics]', name, payload);
  }
}

export function trackPageView({ path, title }) {
  const site = (import.meta.env.VITE_SITE_URL || 'https://gstprime.in').replace(/\/+$/, '');
  const pathname = String(path || window.location.pathname || '/');
  track('page_view', {
    page_location: `${site}${pathname}`,
    page_path: pathname,
    page_title: title || document.title,
  });
}
